export const A4_WIDTH_MM = 210;
export const A4_HEIGHT_MM = 297;
export const PAGE_MARGIN_MM = 10;
export const POLAROID_GAP_MM = 3;

export function computePolaroidGrid(polaroidWidthMm, polaroidHeightMm) {
  const usableW = A4_WIDTH_MM - 2 * PAGE_MARGIN_MM;
  const usableH = A4_HEIGHT_MM - 2 * PAGE_MARGIN_MM;
  const cols = Math.max(1, Math.floor((usableW + POLAROID_GAP_MM) / (polaroidWidthMm + POLAROID_GAP_MM)));
  const rows = Math.max(1, Math.floor((usableH + POLAROID_GAP_MM) / (polaroidHeightMm + POLAROID_GAP_MM)));
  return { cols, rows, perPage: cols * rows };
}

export function layoutPolaroidsOnPages(itemCount, polaroidWidthMm, polaroidHeightMm) {
  const { cols, rows, perPage } = computePolaroidGrid(polaroidWidthMm, polaroidHeightMm);
  const pageCount = Math.max(1, Math.ceil(itemCount / perPage));
  const pages = [];

  for (let pageIndex = 0; pageIndex < pageCount; pageIndex += 1) {
    const slots = [];
    const start = pageIndex * perPage;
    const end = Math.min(start + perPage, itemCount);
    for (let slotIndex = start; slotIndex < end; slotIndex += 1) {
      const indexInPage = slotIndex - start;
      const col = indexInPage % cols;
      const row = Math.floor(indexInPage / cols);
      slots.push({
        itemIndex: slotIndex,
        leftMm: PAGE_MARGIN_MM + col * (polaroidWidthMm + POLAROID_GAP_MM),
        topMm: PAGE_MARGIN_MM + row * (polaroidHeightMm + POLAROID_GAP_MM),
        widthMm: polaroidWidthMm,
        heightMm: polaroidHeightMm,
      });
    }
    pages.push({ pageIndex, slots, cols, rows, perPage });
  }

  return { pages, cols, rows, perPage };
}
